import { resetUnreadCounterForChannel } from '@/graphql/cache/cache-mutations';
import { useReadAllMessagesForChannelMutation } from '@/types/generated/graphql';
import { notification } from 'antd';

export const useReadAllMessagesForChannel = () => {
  const [readAllMessagesForChannel, { loading }] = useReadAllMessagesForChannelMutation();

  function readAllMessagesForChannelHandler(channelId: number) {
    readAllMessagesForChannel({
      variables: {
        channelId,
      },

      onCompleted: (res) => {
        notification.success({
          message: res?.readAllMessagesForChannel?.message,
        });

        resetUnreadCounterForChannel(channelId);
      },

      onError: (res) => {
        notification.error({
          message: res?.message,
        });
      },
    });
  }

  return {
    readAllMessagesForChannelHandler,
    loading,
  };
};
